export class SilentError extends Error {}
